<template>
  <div class="table-container">
    <table class="table hide-medium" border="0" cellspacing="0" cellpadding="0">
      <thead class="table-header">
        <tr>
          <th v-for="data in !config.isManual ? headers : manualHeaders" :key="data" class="table-header-item">
            {{ data }}
          </th>
        </tr>
      </thead>

      <tbody class="table-content">
        <tr
          v-for="item in tableValues"
          :key="item.publicId"
          class="table-line"
          @click="$router.push({ path: '/ResultImportCompanies', query: { id: item.publicId } })"
        >
          <td class="table-item read">
            <div class="item">{{ $utils.formatDate(item.createdAt) }}</div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">{{ $utils.splitStringBySegmentLength(item.totalCompanies) }}</div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{
                  ...item,
                  actionType: 14,
                  total: $utils.splitStringBySegmentLength(item.totalCompaniesInactive),
                }"
              />
            </div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{
                  ...item,
                  actionType: 11,
                  total: $utils.splitStringBySegmentLength(item.totalCompaniesArchived),
                }"
              />
            </div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{ ...item, actionType: 6, total: $utils.splitStringBySegmentLength(item.totalCompaniesFail) }"
              />
            </div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{
                  ...item,
                  actionType: 12,
                  total: $utils.splitStringBySegmentLength(item.totalCompaniesAdded),
                }"
              />
            </div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{
                  ...item,
                  actionType: 10,
                  total: $utils.splitStringBySegmentLength(item.totalCompaniesPending),
                }"
              />
            </div>
          </td>
          <td v-if="!config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{
                  ...item,
                  actionType: 13,
                  total: $utils.splitStringBySegmentLength(item.totalCompaniesUpdated),
                }"
              />
            </div>
          </td>
          <td v-if="config.isManual" class="table-item item-hover read companyName">
            <div class="item companyName" @click.stop="goToCompany(item, $event)">{{ item.companyName }}</div>
          </td>
          <td v-if="config.isManual" class="table-item read">
            <div class="item">
              <ActionType
                :config="{ style: '', showWording: config.isManual }"
                :is-manual="true"
                :company="{ ...item, actionType: getActionType(item), total: '' }"
              />
            </div>
          </td>
          <td class="table-item read">
            <div v-if="item.userPublicId && getManagerInfos(item.userPublicId)" class="item">
              {{ getManagerInfos(item.userPublicId).firstName }} {{ getManagerInfos(item.userPublicId).lastName }}
            </div>
            <div v-else class="item">-</div>
          </td>
        </tr>
        <tr v-if="loading || !tableValues.length" class="table-line empty">
          <td class="table-item" :colspan="config.isManual ? 5 : 9">
            <div class="item">
              <div v-if="loading" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {{ loading ? $t('searchInProgress') : $t('noResult') }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="table-container show-medium">
      <div v-for="item in tableValues" :key="item.id" class="table-line">
        <div class="line">
          <div class="line-content">
            <div class="item">{{ $utils.formatDate(item.createdAt) }}</div>
          </div>
          <div v-if="!config.isManual" class="line-content">
            <span class="line-prefix">Total : </span>
            <div class="item">{{ $utils.splitStringBySegmentLength(item.totalCompanies) }}</div>
          </div>
          <div v-if="config.isManual" class="line-content">
            <div class="item">
              <ActionType :config="{ style: '', showWording: true }" :is-manual="true" :company="{ ...item, actionType: getActionType(item), total: '' }" />
            </div>
          </div>
        </div>

        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{
                ...item,
                actionType: 11,
                total: $utils.splitStringBySegmentLength(item.totalCompaniesInactive),
              }"
            />
          </div>
        </div>
        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{
                ...item,
                actionType: 11,
                total: $utils.splitStringBySegmentLength(item.totalCompaniesArchived),
              }"
            />
          </div>
        </div>
        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{ ...item, actionType: 6, total: $utils.splitStringBySegmentLength(item.totalCompaniesFail) }"
            />
          </div>
        </div>
        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{ ...item, actionType: 12, total: $utils.splitStringBySegmentLength(item.totalCompaniesAdded) }"
            />
          </div>
        </div>
        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{
                ...item,
                actionType: 10,
                total: $utils.splitStringBySegmentLength(item.totalCompaniesPending),
              }"
            />
          </div>
        </div>
        <div v-if="!config.isManual" class="line">
          <div class="item">
            <ActionType
              :config="{ style: '', showWording: true }"
              :is-manual="true"
              :company="{
                ...item,
                actionType: 13,
                total: $utils.splitStringBySegmentLength(item.totalCompaniesUpdated),
              }"
            />
          </div>
        </div>
        <div v-if="config.isManual" class="line column">
          <div class="line-content title">
            <div class="item">{{ $t('companyLabel') }}</div>
          </div>
          <div class="line-content">
            <div class="item label">{{ item.companyName }}</div>
          </div>
        </div>
        <div v-if="item.userPublicId && getManagerInfos(item.userPublicId)" class="line column">
          <div class="line-content title">
            <div class="item">{{ $t('addedBy') }}</div>
          </div>
          <div class="line-content">
            <div class="item">{{ getManagerInfos(item.userPublicId).firstName }} {{ getManagerInfos(item.userPublicId).lastName }}</div>
          </div>
        </div>
      </div>
    </div>

    <Pagination
      v-if="tableValues && tableValues.length"
      :pagination="pagination"
      :set-page="setPage"
      :tableValues="tableValues"
      :pages="pages"
      :disable-dots="disableDots"
    />
  </div>
</template>

<script>
import ActionType from '@/components/actionType';
import Pagination from '@/components/Pagination';
import tableMixin from '@/components/tables/TableMixin';

export default {
  components: { Pagination, ActionType },
  mixins: [tableMixin],

  props: {
    config: {
      type: Object,
      required: false,
      default: () => ({ pagination: false, isManual: false }),
    },

    packages: {
      type: Array,
      required: true,
    },

    users: {
      type: Array,
      required: true,
    },

    filters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      manualHeaders: [this.$t('date'), this.$t('companyLabel'), this.$t('status'), this.$t('addedBy')],
      headers: [
        this.$t('date'),
        this.$t('totalCompanies'),
        this.$t('totalCompaniesInactive'),
        this.$t('totalCompaniesArchived'),
        this.$t('totalCompaniesFail'),
        this.$t('totalCompaniesAdded'),
        this.$t('totalCompaniesPending'),
        this.$t('totalCompaniesUpdated'),
        this.$t('addedBy'),
      ],
      values: [],
      tableMixinConfig: {
        backendPaginated: true,
        onChange: this.changePage,
        getData: this.getData,
        maxElement: 10,
      },
      loading: false,
    };
  },

  watch: {
    'config.isManual'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getData();
      }
    },

    'filters.managerPublicId'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getData();
      }
    },
  },

  methods: {
    getActionType(item) {
      if (item.totalCompanies >= 1) {
        if (item.totalCompaniesAdded >= 1) {
          return 12;
        } else if (item.totalCompaniesArchived) {
          return 11;
        } else if (item.totalCompaniesFail) {
          return 6;
        } else if (item.totalCompaniesInactive) {
          return 14;
        } else if (item.totalCompaniesPending) {
          return 10;
        } else if (item.totalCompaniesUpdated) {
          return 13;
        }
      }
    },

    async getData(pageNumber = 0, pageSize = this.tableMixinConfig.maxElement) {
      this.loading = true;
      this.values = [];
      let data;
      if (!this.filters.isFiltered) {
        data = await this.$store.dispatch('getHistoryImports', {
          pageNumber,
          pageSize,
          managerPublicId: this.filters.managerPublicId,
          isManual: this.config.isManual || false,
        });
      } else {
        data = await this.$store.dispatch('getHistoryImports', {
          pageNumber,
          pageSize,
          search: this.filters.search,
          managerPublicId: this.filters.managerPublicId,
          isManual: this.config.isManual || false,
        });
      }
      this.values = data.items;
      this.pagination.totalLength = data.count;
      this.pagination.maxPage = Math.ceil(this.pagination.totalLength / this.pagination.maxElement);
      this.loading = false;
      return { data, values: data.items };
    },

    getMonitoringInfos(packageId) {
      const info = this.packages.find(value => value.publicId === packageId);
      return info;
    },

    getManagerInfos(managerId) {
      const info = this.users.find(value => value.id === managerId);
      return info;
    },

    goToCompany(importLine, e) {
      e.preventDefault();
      this.$store.dispatch('getHistoryImportById', { id: importLine.publicId }).then(imports => {
        this.$router.push(`/search/${imports.importsHistories.items[0].siren}`);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.table-item.companyName {
  width: 40%;
}
.table-item.item-hover .item:hover {
  text-decoration: underline;
}

.table .table-content .table-line,
.table-container .table-line {
  &:hover {
    cursor: pointer;

    .table-item {
      background: rgba(colors.$unread-table-color, 0.2);
    }
  }

  &.empty .table-item .item {
    display: flex;
    align-items: center;
    justify-content: center;
    color: colors.$lightblue-color;
    .lds-ring {
      margin-right: 24px;
    }
  }
}
.table .table-content .table-line .table-item,
.table-container .table-line .line .line-content {
  &.monitoring {
    display: flex;
    align-items: center;

    .item {
      &:nth-child(2n) {
        color: colors.$red-color !important;
        font-size: 14px;
      }

      &:not(:nth-child(2n)) {
        flex-shrink: 0;
        width: 17px;
        height: 17px;
        background: colors.$red-color;
        color: colors.$white-color !important;
        border-radius: 50%;
        font-size: 12px;
        margin: 0 8px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &.edit {
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
      font-size: 12px;
      background: colors.$grey-color;
      border-radius: 4px;
      color: colors.$white-color;
    }
  }

  &.read-indication {
    .item {
      position: relative;
      padding-left: 12px;

      &:nth-child(2n + 1):before {
        position: absolute;
        left: 0px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        content: '';
        display: flex;
        align-items: center;
        justify-content: center;
        background: colors.$green-color;
      }
    }

    &.read .item:nth-child(2n + 1):before {
      width: 5px;
      height: 5px;
      border: 1px solid colors.$grey-color;
      background: colors.$read-table-color;
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .table-container {
    width: 100%;

    .table-line {
      width: 100%;
      margin: 12px 0;
      display: flex;
      flex-direction: column;

      background: colors.$unread-table-color;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 4px;

      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;

        margin: 12px 0;

        &.right {
          justify-content: flex-end;
        }

        &.column {
          flex-direction: column;
          justify-content: space-evenly;
          align-items: flex-start;
        }

        .line-content {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .line-prefix {
            margin-right: 6px;
            font-weight: 500;
            color: colors.$grey-color;
            line-height: 16px;
            font-size: 14px;
          }

          .item {
            display: flex;
            align-items: center;
          }

          &.read-indication {
            align-self: flex-end;
          }

          &.title {
            font-weight: 500;
            color: colors.$grey-color;
            line-height: 16px;
            font-size: 14px;
            margin-bottom: 8px;
          }

          &.label,
          &.date {
            font-weight: 500;
            color: colors.$black-color;
          }

          &.date,
          .internal-id {
            font-size: 12px;
          }

          &.label {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
